export const LEAD_STATUS = 1
export const PROSPECT_STATUS = 2
export const ACCOUNT_STATUS = 3
export const MANAGER_BUCKET_STATUS = 4
export const INACTIVE_STATUS = 5
export const PENDING_STATUS = 8
export const VERIFIED_LEAD_STATUS = 9

export const contactStatusesOptions = [
  { id: 1, name: 'Lead' },
  { id: 2, name: 'Prospect' },
  { id: 3, name: 'Account' },
  { id: 4, name: 'Manager Bucket' },
  { id: 5, name: 'Inactive' },
]

// Status changes statuses
export const DEAD_STATUS = 6
export const NOT_QUALIFIED_STATUS = 7

const mapedStatuses = new Map()
mapedStatuses.set(LEAD_STATUS, 'Lead')
mapedStatuses.set(PROSPECT_STATUS, 'Prospect')
mapedStatuses.set(ACCOUNT_STATUS, 'Account')
mapedStatuses.set(MANAGER_BUCKET_STATUS, 'Manager`s Bucket')
mapedStatuses.set(INACTIVE_STATUS, 'Inactive')
mapedStatuses.set(DEAD_STATUS, 'Dead')
mapedStatuses.set(NOT_QUALIFIED_STATUS, 'Not Qualified')
mapedStatuses.set(PENDING_STATUS, 'Pending')
mapedStatuses.set(VERIFIED_LEAD_STATUS, 'Verified Lead')

export const getStatus = (id) => {
  return mapedStatuses.get(id)
}
